import { render, staticRenderFns } from "./ViewChallenge.vue?vue&type=template&id=22424106&scoped=true&"
import script from "./ViewChallenge.vue?vue&type=script&lang=js&"
export * from "./ViewChallenge.vue?vue&type=script&lang=js&"
import style0 from "./ViewChallenge.vue?vue&type=style&index=0&id=22424106&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "22424106",
  null
  
)

export default component.exports